<div class="container">
  <mat-toolbar class="fixed" *ngIf="changesDetected">
    <div class="row is-flex">
      <div class="col s12 text-center">
        <div class="btn-group-vertical">
          <button class="btn btn-primary" (click)="saveRetainPrices()" [disabled]="formulaSubmitted">
            Save All Changes
            <fa-icon *ngIf="formulaSubmitted" icon="spinner" [spin]="true"></fa-icon>
          </button>
          <button class="btn btn-secondary" (click)="discardChanges()" [disabled]="formulaSubmitted">
            Discard Changes
          </button>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <ng-container *ngIf="mycollections$ | async; else noBrands">
    <div
      *ngFor="
        let brand of mycollections$ | async | filterByBrand: brand.selectedBrand | searchList: searchTerm;
        let brandIndex = index
      "
    >
      <div class="row">
        <div class="col m9 s12" text-align-right>
          <h1>{{ brand['brandName'] }}</h1>
        </div>
        <!--         <div class="col m3 s12" text-align-right>
          <button class="btn btn-primary" type="button" mat-button (click)="saveSlowFrames(brand)">
            Save Slow Frames
          </button>
        </div> -->
      </div>
      <div *ngIf="brand.hasClusters">
        <div *ngFor="let cluster of brand['clusters'] | searchList: searchTerm; let clusterIndex = index">
          <div class="row">
            <div class="col m9 s12">
              <h2>{{ cluster.categoryName }} - {{ cluster.clusterName }}<sup>*</sup></h2>
            </div>
            <div class="col m3 s12" *ngIf="brand.hasClusters">
              <div class="btn-group--fill">
                <button
                  class="btn btn-primary"
                  type="button"
                  mat-button
                  (click)="
                    openPriceFormulaDialogCluster(
                      cluster['frames'],
                      cluster['clusterName'],
                      cluster['clusterId'],
                      brand.brandId,
                      cluster.clusterId
                    )
                  "
                >
                  Set Kit Retail Price Formula
                </button>
              </div>
            </div>
          </div>
          <!-- Data Table -->
          <div class="data-table mt-30">
            <div
              class="data-table-header mat-header-row collection__table-header-mobile"
              matSort
              (matSortChange)="sortData($event)"
            >
              <span>
                <span class="col s12 data-table-cell data-table-cell-show-small" mat-sort-header="smallImageUrl">
                  Frame Details
                </span>
              </span>
            </div>
            <div
              class="data-table-header mat-header-row collection__table-header-desktop"
              matSort
              (matSortChange)="sortData($event)"
            >
              <!--s2 s2 s2 s1 s2 s1 s1 s1-->
              <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="smallImageUrl">
                Image
              </span>

              <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="module">
                Module
              </span>

              <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="styleName">
                Style Name
              </span>

              <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="colorDescription">
                Color
              </span>

              <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="eyeSize">
                Size
              </span>

              <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="upc">
                UPC
              </span>

              <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="wholesalePrice">
                <span *ngIf="['wholesale price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                  >Wholesale Price</span
                >
              </span>

              <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="purchasePrice">
                <span *ngIf="['net price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                  >Purchase Price</span
                >
              </span>

              <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="retailPrice">
                Retail Price
              </span>
            </div>
            <section class="data-table-tbody">
              <div
                class="row data-table-row"
                *ngFor="let frame of cluster['frames'] | searchList: searchTerm; let i = index"
              >
                <div class="col s12 m12 l1 data-table-cell product-item__image">
                  <div class="data-table-data frame--image">
                    <img
                      [src]="frame['largeImageUrl']"
                      [alt]="frame['largeImageUrl']"
                      class="collection__frame-image"
                      onError="this.src='/assets/images/frame-default-sm.png'"
                    />
                  </div>
                  <div class="row hide-desktop">
                    <div class="col s12">
                      <div class="row">
                        <div class="col s12">
                          <button
                            class="accordion"
                            (click)="panelDisplay[i] = panelDisplay[i] === 'block' ? 'none' : 'block'"
                          >
                            <strong>Style Name</strong> {{ frame['styleName'] }}
                          </button>
                          <div class="panel" [ngStyle]="{ display: panelDisplay[i] }">
                            <div class="row">
                              <div class="col s12">
                                <div class="row">
                                  <div class="col s4">
                                    <strong>Color</strong>
                                  </div>
                                  <div class="col s8">
                                    {{ frame['colorDescription'] }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col s4">
                                    <strong>Size</strong>
                                  </div>
                                  <div class="col s8">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</div>
                                </div>
                                <div class="row">
                                  <div class="col s4">
                                    <strong>UPC</strong>
                                  </div>
                                  <div class="col s8">
                                    {{ frame['upc'] }}
                                  </div>
                                </div>

                                <div
                                  class="row"
                                  *ngIf="
                                    ['wholesale price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1
                                  "
                                >
                                  <div class="col s4">
                                    <strong>Wholesale Price</strong>
                                  </div>
                                  <div class="col s8">
                                    {{ frame['wholesalePrice'] }}
                                  </div>
                                </div>
                                <div
                                  class="row"
                                  *ngIf="['net price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                                >
                                  <div class="col s4">
                                    <strong>Purchase Price</strong>
                                  </div>
                                  <div class="col s8">
                                    {{ frame['purchasePrice'] }}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col s4">
                                    <strong>Retail</strong>
                                  </div>
                                  <div class="col s8">
                                    <input
                                      type="text"
                                      [(ngModel)]="frame['retailPrice']"
                                      placeholder="Retail Price"
                                      (keyup)="valueChanged()"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col s2 data-table-cell hide-mobile">
                  <span class="data-table-data">{{ frame['moduleName'] }}</span>
                </div>
                <div class="col s1 data-table-cell hide-mobile">
                  <span class="data-table-data">{{ frame['styleName'] }}</span>
                </div>
                <div class="col s2 data-table-cell hide-mobile">
                  <span class="data-table-data">{{ frame['colorDescription'] }}</span>
                </div>
                <div class="col s1 data-table-cell hide-mobile">
                  <span class="data-table-data">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</span>
                </div>
                <div class="col s2 data-table-cell hide-mobile">
                  <span class="data-table-data">{{ frame['upc'] }}</span>
                </div>
                <div class="col s1 data-table-cell hide-mobile">
                  <span
                    class="data-table-data"
                    *ngIf="['wholesale price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                    >{{ frame['wholesalePrice'] }}</span
                  >
                </div>
                <div class="col s1 data-table-cell hide-mobile">
                  <span
                    class="data-table-data"
                    *ngIf="['net price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                    >{{ frame['purchasePrice'] }}</span
                  >
                </div>
                <div class="col s1 data-table-cell hide-mobile">
                  <span class="data-table-data"
                    ><input type="text" [(ngModel)]="frame['retailPrice']" (keyup)="valueChanged()"
                  /></span>
                </div>
              </div>
            </section>
          </div>
          <!-- END Data Table -->
        </div>
      </div>
      <div *ngFor="let module of brand['modules'] | searchList: searchTerm; let moduleIndex = index">
        <div class="row">
          <div class="col m9 s12">
            <h2>{{ module.categoryName }} - {{ module.moduleName }}</h2>
          </div>
          <div class="col m3 s12">
            <div class="btn-group--fill">
              <button
                class="btn btn-primary"
                type="button"
                mat-button
                (click)="
                  openPriceFormulaDialog(
                    module['frames'],
                    module['moduleName'],
                    module['moduleId'],
                    brand.brandId,
                    module.index
                  )
                "
              >
                Set Kit Retail Price Formula
              </button>
            </div>
          </div>
        </div>
        <!-- Data Table ✝-->
        <div class="data-table mt-30">
          <div
            class="data-table-header mat-header-row collection__table-header-mobile"
            matSort
            (matSortChange)="sortData($event)"
          >
            <span>
              <span class="col s12 data-table-cell data-table-cell-show-small" mat-sort-header="smallImageUrl">
                Frame Details
              </span>
            </span>
          </div>
          <div
            class="data-table-header mat-header-row collection__table-header-desktop"
            matSort
            (matSortChange)="sortData($event)"
          >
            <!--s2 s1 s2 s1 s2 s1 s1 s1-->
            <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="smallImageUrl">
              Image
            </span>
            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="module">
              Module
            </span>
            <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="styleName">
              Style Name
            </span>

            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="colorDescription">
              Color
            </span>

            <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="eyeSize">
              Size
            </span>

            <span class="col s2 data-table-cell data-table-cell-show-small" mat-sort-header="upc">
              UPC
            </span>

            <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="wholesalePrice">
              <span *ngIf="['wholesale price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                >Wholesale Price</span
              >
            </span>

            <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="purchasePrice">
              <span *ngIf="['net price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                >Purchase Price</span
              >
            </span>

            <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="retailPrice">
              Retail Price
            </span>
            <!--             <span class="col s1 data-table-cell data-table-cell-show-small" mat-sort-header="retailPrice">
              Slow Mover
            </span> -->
          </div>
          <section class="data-table-tbody">
            <div
              class="row data-table-row"
              *ngFor="let frame of module['frames'] | searchList: searchTerm; let i = index"
            >
              <div class="col s12 m12 l1 data-table-cell product-item__image">
                <div class="data-table-data frame--image">
                  <img
                    [src]="frame['largeImageUrl']"
                    [alt]="frame['largeImageUrl']"
                    class="collection__frame-image"
                    onError="this.src='/assets/images/frame-default-sm.png'"
                  />
                </div>
                <div class="row hide-desktop">
                  <div class="col s12">
                    <div class="row">
                      <div class="col s12">
                        <button
                          class="accordion"
                          (click)="panelDisplay[i] = panelDisplay[i] === 'block' ? 'none' : 'block'"
                        >
                          <strong>Style Name</strong> {{ frame['styleName'] }}
                        </button>
                        <div class="panel" [ngStyle]="{ display: panelDisplay[i] }">
                          <div class="row">
                            <div class="col s12">
                              <div class="row">
                                <div class="col s4">
                                  <strong>Color</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame['colorDescription'] }}
                                </div>
                              </div>
                              <div class="row">
                                <div class="col s4">
                                  <strong>Size</strong>
                                </div>
                                <div class="col s8">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</div>
                              </div>
                              <div class="row">
                                <div class="col s4">
                                  <strong>UPC</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame['upc'] }}
                                </div>
                              </div>

                              <div
                                class="row"
                                *ngIf="['wholesale price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                              >
                                <div class="col s4">
                                  <strong>Wholesale Price</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame['wholesalePrice'] }}
                                </div>
                              </div>
                              <div
                                class="row"
                                *ngIf="['net price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                              >
                                <div class="col s4">
                                  <strong>Purchase Price</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame['purchasePrice'] }}
                                </div>
                              </div>
                              <div class="row">
                                <div class="col s4">
                                  <strong>Retail</strong>
                                </div>
                                <div class="col s8">
                                  <input
                                    type="text"
                                    [(ngModel)]="frame['retailPrice']"
                                    placeholder="Retail Price"
                                    (keyup)="valueChanged()"
                                  />
                                </div>
                              </div>
                              <!--                               <div class="row">
                                <div class="col s4">
                                  <strong>Slow Frame</strong>
                                </div>
                                <div class="col s8">
                                  {{ frame.isSlowFrame }}                                
                                </div>
                              </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['moduleName'] }}</span>
              </div>
              <div class="col s1 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['styleName'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['colorDescription'] }}</span>
              </div>
              <div class="col s1 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['eyeSize'] }}-{{ frame['temple'] }}</span>
              </div>
              <div class="col s2 data-table-cell hide-mobile">
                <span class="data-table-data">{{ frame['upc'] }}</span>
              </div>
              <div class="col s1 data-table-cell hide-mobile">
                <span
                  class="data-table-data"
                  *ngIf="['wholesale price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                  >{{ frame['wholesalePrice'] }}</span
                >
              </div>
              <div class="col s1 data-table-cell hide-mobile">
                <span
                  class="data-table-data"
                  *ngIf="['net price', 'both'].indexOf((user$ | async)?.program.hidePricing) === -1"
                  >{{ frame['purchasePrice'] }}</span
                >
              </div>
              <div class="col s1 data-table-cell hide-mobile">
                <span class="data-table-data"
                  ><input type="text" [(ngModel)]="frame['retailPrice']" (keyup)="valueChanged()"
                /></span>
              </div>
              <!--               <div class="col s1 data-table-cell">
                <mat-checkbox
                  class="data-table-data"
                  [(ngModel)]="frame.isSlowFrame"
                  [checked]="frame.isSlowFrame"
                  [disabled]="brand.isMaxCountReached && !frame.isSlowFrame"
                  (change)="updateCount($event, frame)"
                  name="retCheckBox-{{ brandIndex }}{{ moduleIndex }}{{ i }}"
                ></mat-checkbox>
              </div> -->
            </div>
          </section>
        </div>
        <!-- END Data Table -->
      </div>
    </div>
  </ng-container>
</div>

<ng-template #noBrands>
  <div class="row">
    <div class="col s12">
      <mat-card class="mat-card--widget">
        <mat-card-header>
          <h2 mat-card-title>Check back soon</h2>
        </mat-card-header>
        <mat-card-content class="offers-list__empty">
          <div class="container text-center">
            <h3 class="h3">No Brands Currently Available</h3>
            <p>Sorry, no brands are currently available to you.</p>
            <a routerLink="/" class="btn btn-link">Return to my catalog</a>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</ng-template>
<div></div>
<!-- CanLeave Popup Dialog (based on MatDialog) -->
<ecp-can-leave [dontLeave]="changesDetected" [disableClose]="true" #canLeave>
  <div [class]="theme ? theme : 'one-portal'">
    <h2 mat-dialog-title><b>Unsaved changes</b></h2>

    <mat-dialog-content>
      You have unsaved changes which will be lost. Are you sure you wish to leave this page?
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button class="btn btn-primary" (click)="canLeave.close(false)" cdkFocusInitial>Stay on This Page</button>
      <button class="btn btn-secondary" (click)="canLeave.close(true)">Leave This Page</button>
    </mat-dialog-actions>
  </div>
</ecp-can-leave>
